<div *ngIf="!((formState$ | async)?.loading)">
  <mm-radio-control [parentForm]="parentForm" [radioModel]="transferDirectionModel"></mm-radio-control>
  <mm-banners *ngIf="(instructions$ | async)?.length === 0"
  [bannerText]="['There are no accounts set up for ACH transactions. ']"
  [hyperlink]="noInstructionsErrorLink"
  [type]="'error'">
  </mm-banners>
</div>
